import type { Common, LaPayment } from '@libs/domain';
import { MstRegistration, MstRegistrationRaw } from '@libs/templates/mst';

class LeaseCompanyMstRegistration
  extends MstRegistration
  implements
    Pick<Common['schema'], 'eligibleBillingProvider' | 'phoneNo'>,
    Pick<LaPayment['schema'], 'paymentDay'>
{
  private constructor(
    mstRegistration: MstRegistration,
    readonly phoneNo: string,
    readonly paymentDay: string,
    readonly eligibleBillingProvider: boolean,
  ) {
    super(
      mstRegistration.id,
      mstRegistration.version,
      mstRegistration.code,
      mstRegistration.name,
      mstRegistration.mstSpareName01,
      mstRegistration.mstSpareName02,
      mstRegistration.validityStartDate,
      mstRegistration.validityEndDate,
      mstRegistration.mstNote,
    );
  }

  static init(code?: string) {
    return new LeaseCompanyMstRegistration(MstRegistration.baseInit(code), '', '', false);
  }

  static fromRaw(raw: LeaseCompanyMstRegistrationRaw) {
    return new LeaseCompanyMstRegistration(
      MstRegistration.baseFromRaw(raw),
      raw.phoneNo,
      raw.paymentDay === '0' ? '' : raw.paymentDay,
      raw.eligibleBillingProvider,
    );
  }
}

class LeaseCompanyMstRegistrationRaw
  extends MstRegistrationRaw
  implements
    Pick<Common['record'], 'eligibleBillingProvider' | 'phoneNo'>,
    Pick<LaPayment['record'], 'paymentDay'>
{
  private constructor(
    mstRegistrationRaw: MstRegistrationRaw,
    readonly phoneNo: string,
    readonly paymentDay: string,
    readonly eligibleBillingProvider: boolean,
  ) {
    super(
      mstRegistrationRaw.id,
      mstRegistrationRaw.version,
      mstRegistrationRaw.code,
      mstRegistrationRaw.name,
      mstRegistrationRaw.mstSpareName01,
      mstRegistrationRaw.mstSpareName02,
      mstRegistrationRaw.validityStartDate,
      mstRegistrationRaw.validityEndDate,
      mstRegistrationRaw.mstNote,
    );
  }

  static fromModel(leaseCompanyMstRegistration: LeaseCompanyMstRegistration) {
    return new LeaseCompanyMstRegistrationRaw(
      MstRegistrationRaw.baseFromModel(leaseCompanyMstRegistration),
      leaseCompanyMstRegistration.phoneNo,
      leaseCompanyMstRegistration.paymentDay,
      leaseCompanyMstRegistration.eligibleBillingProvider,
    );
  }
}

export { LeaseCompanyMstRegistration, LeaseCompanyMstRegistrationRaw };
